module.exports = __webpack_public_path__ + "static/media/pollen.360e835e.svg";